import { render, staticRenderFns } from "./CieloButton.vue?vue&type=template&id=65c2d6ec&scoped=true"
import script from "./CieloButton.vue?vue&type=script&lang=js"
export * from "./CieloButton.vue?vue&type=script&lang=js"
import style0 from "./CieloButton.vue?vue&type=style&index=0&id=65c2d6ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c2d6ec",
  null
  
)

export default component.exports